import { render, staticRenderFns } from "./NavbarProfile.vue?vue&type=template&id=23d1002d"
import script from "./NavbarProfile.vue?vue&type=script&lang=js"
export * from "./NavbarProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports